import React from "react";
import { message, Form } from "antd";

import styled from "styled-components";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import DateInput from "components/inputs/DateInput";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import Upload from "components/buttons/Upload";
import { Header } from "components/App/styled";
import { toMysqlDate } from "common";
export default function App({ list, setList, productList, remain, orderId }) {
  const [form] = Form.useForm();

  const [image, setImage] = React.useState([]);
  const [reload, setReload] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setReload(false);
  }, [list.length, list, reload, productList]);

  console.log(list);

  function onSubmit({ type, amount, time, description }) {
    setLoading(true);
    const mysqlTime = toMysqlDate(new Date(time)).slice(0, 10);

    if (type) {
      let newTotal = remain - amount;
      if (newTotal < 0) {
        message.error("مبلغ وارد شده بیشتر از فاکتور است");
      } else {
        const _type = choiceList.findIndex((item) => item.title === type);
        const getOrderId = orderId ? { orderid: orderId } : {};
        setList((e) => [
          ...e,
          {
            type: _type,
            amount,
            time: mysqlTime,
            description: description ? description : "",
            data: JSON.stringify(image),
            status: 0,
            ...getOrderId,
          },
        ]);
        form.resetFields();
      }
    } else {
      message.error("لطفا نام کالای مورد نظر را انتخاب کنید");
    }
    setLoading(false);
  }

  function deleteItem(index, id) {
    setLoading(true);
    var newList = list;
    newList.splice(index, 1);
    setReload(true);
    setList(newList);
    message.success("با موفقیت حذف شد");
  }

  return (
    <Container>
      <Col>
        <Header>پرداختی :</Header>
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <Label>نوع پرداخت :</Label>
          <Form.Item
            name="type"
            rules={[
              {
                required: true,
                message: "لطفا نوع پرداخت را وارد کنید!",
              },
            ]}
            initialValue={"چک"}
          >
            <Select
              borderradius="0"
              list={choiceList}
              showSearch
              placeholder="جستجو"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            />
          </Form.Item>

          <Label>مبلغ :</Label>
          <Form.Item
            name="amount"
            rules={[
              {
                required: true,
                message: "لطفا مبلغ را وارد کنید!",
              },
            ]}
          >
            <NumberInput min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Label>زمان :</Label>
          <Form.Item
            name="time"
            rules={[
              {
                required: true,
                message: "لطفا زمان را وارد کنید!",
              },
            ]}
          >
            <DateInput />
          </Form.Item>

          {/* <AntInput.TextArea rows={5} /> */}
          <Label>توضیحات :</Label>
          <Form.Item name="description">
            <Input size="large" placeholder="" />
          </Form.Item>
          <Upload maxAllowed={20} setImage={setImage} addedImages={image} />
          <Button htmlType="submit" style={{ width: "100%", marginTop: 16 }}>
            <PlusOutlined style={{ marginLeft: 12 }} /> اضافه کردن
          </Button>
        </Form>
      </Col>

      <ColLeft>
        <Header>لیست پرداختی ها</Header>
        <Table>
          <TableRow>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              نوع
            </span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              مبلغ
            </span>
            <span className="cell" style={{ borderLeft: "1px solid #3a4041" }}>
              زمان
            </span>
            <span className="cell" style={{ maxWidth: 76 }}>
              حذف
            </span>
          </TableRow>
          {list?.length
            ? list.map((item, index) => (
                <TableRow key={index}>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.type}
                  </span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.amount}
                  </span>
                  <span
                    className="cell"
                    style={{ borderLeft: "1px solid #3a4041" }}
                  >
                    {item.time}
                  </span>
                  <span className="cell" style={{ maxWidth: 76 }}>
                    <span className="cell" style={{ maxWidth: 76 }}>
                      <DeleteButton
                        onClick={() => deleteItem(index, item.id)}
                      />
                    </span>
                  </span>
                </TableRow>
              ))
            : null}
        </Table>
        <RemainContainer>باقی مانده : {remain}</RemainContainer>
      </ColLeft>
    </Container>
  );
}
const Container = styled.div`
  display: flex;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;

  @media (max-width: 480px) {
    margin-top: 36px;
  }
`;
const ColLeft = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  margin-right: 64px;

  width: calc(100% - 300px);

  @media (max-width: 480px) {
    margin-top: 36px;
    margin-right: 0;
    width: 100%;
  }
`;

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const Table = styled.div`
  border: 1px solid ${colors.primary};
  border-radius: 3px;
  overflow-x: auto;
  border-bottom: none;
`;
const TableRow = styled.div`
  border-bottom: 1px solid ${colors.primary};
  display: flex;
  & .cell {
    width: 50%;
    text-align: center;
    padding: 3px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .title-row {
    border-left: 1px solid #3a4041;
    width: 40%;
    display: block;
    text-align: start;
    display: flex;
    align-items: center;
  }
`;
const DeleteButton = styled(DeleteOutlined)`
  color: ${colors.red};
  cursor: pointer;
  text-align: center;
  font-size: 17px;
  position: relative;
  top: 2px;
`;
const RemainContainer = styled.div`
  margin-top: 18px;
`;

const choiceList = [{ title: "نقدی" }, { title: "چک" }];
